/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_IntroInputs */

const en_pc_tut_secure_intro = /** @type {(inputs: Pc_Tut_Secure_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft opens and saves encrypted documents from 40-bit RC4 up to AES-256.`)
};

const zh_pc_tut_secure_intro = /** @type {(inputs: Pc_Tut_Secure_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 支持打开和保存从 40 位 RC4 到 AES-256 加密的文档。`)
};

/**
* | output |
* | --- |
* | "PdfCraft opens and saves encrypted documents from 40-bit RC4 up to AES-256." |
*
* @param {Pc_Tut_Secure_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_intro = /** @type {((inputs?: Pc_Tut_Secure_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_intro(inputs)
	return zh_pc_tut_secure_intro(inputs)
});
export { pc_tut_secure_intro as "pc.tut.secure.intro" }